import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { convertNumber } from 'helpers/utils';

import { InfoCard, InfoCardBlock, InfoCardLink } from 'components/InfoCard';

const InfoCardsSection = ({ reserve, stock, showEmpty }) => {
  const [cardPending, setCardPending] = useState(true);

  useEffect(() => {
    if (reserve) {
      setCardPending(false);
    } else {
      setCardPending(true);
    }
  }, [reserve]);

  return (
    <div className="reserve-section">
      <InfoCard title="Клиент" pending={cardPending} showCard={!!showEmpty} showContent={!!reserve?.client}>
        <InfoCardBlock title="ФИО" text={reserve?.client?.FIO} />
        <InfoCardBlock title="Номер" text={convertNumber(reserve?.client?.PhMain)} />
        <InfoCardLink
          title="Перейти в профиль"
          link={{
            url: `/client/${reserve?.client?.id}`,
            params: {
              redirectFromReserve: `/reservation${reserve.actID1C ? `/${reserve.actID1C}` : ''}`,
            },
          }}
        />
      </InfoCard>

      <InfoCard title="Общее" pending={cardPending} showCard={!!showEmpty} showContent={!!(stock || reserve?.time)}>
        {stock && <InfoCardBlock title="Склад" text={stock?.stockName} />}

        {reserve?.time && (
          <InfoCardBlock title="Время" text={`до ${moment(reserve.time * 1000).format('HH:mm DD.MM')}`} />
        )}
      </InfoCard>

      <InfoCard title="Комментарий" showCard={!!showEmpty} showContent={!!reserve?.comment} pending={cardPending}>
        {reserve.comment}
      </InfoCard>
    </div>
  );
};

InfoCardsSection.propTypes = {
  reserve: PropTypes.any,
  stock: PropTypes.any,
  showEmpty: PropTypes.bool,
};

InfoCardsSection.defaultProps = {
  reserve: null,
  stock: null,
  showEmpty: true,
};

export { InfoCardsSection };
